import React, { Component } from "react";
import styles from "./detailBloodStationBackButton.module.scss";
import redirectTo from "../../../utils/redirectTo";
import { sendMetrics } from "../../../utils/misc";

export default class DetailBloodStationBackButton extends Component<any, any> {
  props: {
    linkTo?: string;
  };

  getBack = (linkTo) => {
    sendMetrics("from_bs_to_map");
    redirectTo(linkTo);
  };

  back = (linkTo) => {
    if (typeof window !== "undefined") {
      const prevPath = window.sessionStorage.getItem("prevPath");
      if (prevPath !== "null" && prevPath.includes("recipient"))
        redirectTo(prevPath);
      else this.getBack(linkTo);
    } else this.getBack(linkTo);
  };

  render() {
    const { props } = this;
    const { linkTo } = props;

    let isBack = false;

    if (typeof window !== "undefined") {
      const prevPath = window.sessionStorage.getItem("prevPath");
      if (prevPath !== "null" && prevPath.includes("recipient")) isBack = true;
    }

    return (
      <div className={styles.DetailBloodStationBackButton}>
        <div
          onClick={() => this.back(linkTo)}
          className={styles.DetailBloodStationBackButton_Container}
        >
          <img src="/static/images/arrows/backProfile.svg" alt="" />
          <span>{isBack ? "Назад" : "На карте"}</span>
        </div>
      </div>
    );
  }
}
